<template>
  <div class="fileUploaderItemItem">
    <div
      :key="name"
      :class="['fileUploaderItem__fileName', { 'fileUploaderItem__fileName--asUrl': url }]"
      @click="downloadFile"
    >
      <span :class="['fileUploaderItem__fileIcon', getIconClass(type)]" />
      {{ slicedName }}
      <span
        v-if="!disabled && !url"
        class="icon-line-close-bold fileUploaderItem__closeIcon"
        @click="$emit('removeFile')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileUploaderItem',
  props: {
    name: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    slicedName() {
      const limit = 35;
      if (this.name.length > limit) {
        const dotIndex = this.name.lastIndexOf('.');
        const extension = this.name.substring(dotIndex);
        const result = this.name.substring(0, limit - extension.length - 5) + '(...)' + extension;
        return result;
      } else {
        return this.name;
      }
    },
  },
  methods: {
    getIconClass(type) {
      if (type.includes('image')) return 'icon-border-image';
      if (type.includes('pdf')) return 'icon-border-pdf';
      if (type.includes('excel')) return 'icon-border-xls';
      else return 'icon-border-text';
    },
    async downloadFile() {
      try {
        if (this.url) {
          const {
            data: { downloadUrl },
          } = await this.$axios.get(this.url);
          if (downloadUrl) {
            window.open(downloadUrl);
          }
        }
      } catch {}
    },
  },
};
</script>

<style lang="scss">
.fileUploaderItem {
  &__fileName {
    color: $cMainDark;
    font-size: 1.1rem;
    line-height: 1.4rem;
    font-weight: 700;
    height: 3rem;
    background-color: rgba($cAddNeutral, 0.2);
    padding: 0.7rem 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;

    &--asUrl {
      cursor: pointer;
    }
  }

  &__fileIcon {
    color: $cAddNeutral;
    margin-right: 1rem;
    font-size: 2rem;
  }

  &__closeIcon {
    font-size: 0.8rem;
    color: $cAddDark02;
    cursor: pointer;
    margin-left: 1.4rem;
  }
}
</style>
